import { keyframes, css } from 'styled-components'

const slideInAndOut = keyframes`
  from {
    top: 100%;
  }

  40% {
    top: 0;
  }

  60% {
    top: 0;
  }

  to {
    top: 100%;
  }
`

const animation = css`
  animation: ${slideInAndOut} 1700ms cubic-bezier(0.87, 0, 0.13, 1); /* easeInOutExpo */
`

export default animation
